import React from "react";

class BaseComponent<Props = { [key: string]: any }, State = { [key: string]: any }> extends React.Component<
    Props,
    State
> {
    unsubscribes: Array<() => {}> = [];

    constructor(props: Props) {
        super(props);
    }

    listenTo(
        store: {
            listen: any;
        },
        func: (some: any) => void
    ): void {
        if (store && func) {
            const unsubscribe = store.listen(func);
            // this can only be undefined in tests, but checking for it prevents
            // some spam
            if (unsubscribe) {
                this.unsubscribes.push(unsubscribe);
            }
        }
    }

    componentWillUnmount() {
        this.unsubscribes.forEach((unsubscribe) => unsubscribe());
    }
}

export default BaseComponent;
